import { render, staticRenderFns } from "./reg_second.vue?vue&type=template&id=200bada2&scoped=true"
import script from "./reg_second.vue?vue&type=script&lang=js"
export * from "./reg_second.vue?vue&type=script&lang=js"
import style0 from "./reg_second.vue?vue&type=style&index=0&id=200bada2&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200bada2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200bada2')) {
      api.createRecord('200bada2', component.options)
    } else {
      api.reload('200bada2', component.options)
    }
    module.hot.accept("./reg_second.vue?vue&type=template&id=200bada2&scoped=true", function () {
      api.rerender('200bada2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/landingpage/reg_second.vue"
export default component.exports